export { StyledLabel } from './StyledLabel';
